var _excluded = ["children", "isExpanded", "less", "lines", "tag", "more", "toggleExpand", "renderEllipsis", "btnStyle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
//
import * as React from 'react';
import { color } from "../../styles/theme";
import Button from "./Button";
import { compose, withStateHandlers } from 'recompose';
import Truncate from "./Truncate";
import cx from 'classnames';
function ExpandableLink(_ref) {
  var text = _ref.text,
    hasEllipsis = _ref.hasEllipsis,
    onClick = _ref.onClick,
    btnStyle = _ref.btnStyle;
  var textClassName = 'text-uppercase font-sm bold';
  return /*#__PURE__*/React.createElement("span", {
    className: textClassName
  }, hasEllipsis && '...', ' ', /*#__PURE__*/React.createElement(Button, {
    style: btnStyle,
    rootClassName: cx(textClassName, 'p-a-0'),
    onClick: onClick,
    type: "link"
  }, text));
}
function renderEllipsisFn(_ref2) {
  var more = _ref2.more,
    less = _ref2.less,
    isExpanded = _ref2.isExpanded,
    toggleExpand = _ref2.toggleExpand,
    btnStyle = _ref2.btnStyle;
  return isExpanded ? /*#__PURE__*/React.createElement(ExpandableLink, {
    text: less,
    onClick: toggleExpand,
    btnStyle: btnStyle
  }) : /*#__PURE__*/React.createElement(ExpandableLink, {
    hasEllipsis: true,
    text: more,
    onClick: toggleExpand,
    btnStyle: btnStyle
  });
}
function ReadMore(_ref3) {
  var children = _ref3.children,
    isExpanded = _ref3.isExpanded,
    _ref3$less = _ref3.less,
    less = _ref3$less === void 0 ? 'Less' : _ref3$less,
    _ref3$lines = _ref3.lines,
    lines = _ref3$lines === void 0 ? 2 : _ref3$lines,
    _ref3$tag = _ref3.tag,
    tag = _ref3$tag === void 0 ? 'span' : _ref3$tag,
    _ref3$more = _ref3.more,
    more = _ref3$more === void 0 ? 'More' : _ref3$more,
    toggleExpand = _ref3.toggleExpand,
    _ref3$renderEllipsis = _ref3.renderEllipsis,
    renderEllipsis = _ref3$renderEllipsis === void 0 ? renderEllipsisFn : _ref3$renderEllipsis,
    btnStyle = _ref3.btnStyle,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var combinedBtnStyle = Object.assign({
    color: color.primary,
    verticalAlign: 'baseline',
    minHeight: 28
  }, btnStyle);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Truncate, _extends({
    tag: tag,
    lines: !isExpanded && lines,
    ellipsis: renderEllipsis({
      more: more,
      less: less,
      toggleExpand: toggleExpand,
      isExpanded: false,
      btnStyle: combinedBtnStyle
    })
  }, rest), children), isExpanded && renderEllipsis({
    more: more,
    less: less,
    toggleExpand: toggleExpand,
    isExpanded: true,
    btnStyle: combinedBtnStyle
  }));
}
ReadMore.defaultProps = {
  lines: 2,
  more: 'More',
  less: 'Less',
  tag: 'span'
};
export default compose(withStateHandlers({
  isExpanded: false
}, {
  toggleExpand: function toggleExpand(_ref4) {
    var isExpanded = _ref4.isExpanded;
    return function () {
      return {
        isExpanded: !isExpanded
      };
    };
  }
}))(ReadMore);